<template>
<div>
  <Grid name="modalactivitiesGrid" ref="modalactivitiesGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
export default {
  name: 'Actividades',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [{
        api: 'familymembertypes/lst',
        field: 'family_member_type_id'
      }],
      schemaModelFields: {},
      url: 'activities',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'Selecionar',
          click: this.selectItem
        }
      }, {
        field: 'id',
        title: 'ID'
      }, {
        field: 'name',
        title: 'Name'
      }, {
        field: 'family_member_type_id',
        title: 'Escalão'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    }
  },
  methods: {
    selectItem(e) {
      e.preventDefault()
      var grid = this.$refs.modalactivitiesGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('select-item', {
        item: dataItem
      })
    }
  }
}
</script>
